import { message } from "antd";
import * as ACTIONS from "app/actions/ListadoKeyUserActions";

const initialState = {
    isLoadingFilters: false,
    filter: {
        listNames: [],
        listSystems: [],
    },
    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    isLoadingAllKeyUser: false,
    listAllKeyUser: [],
};

export const ListadoKeyUserReducer = (state = initialState, action) => {
    switch (action.type) {
        //Obtiene la tabla
        case ACTIONS.GET_KEYUSER_LIST_REQUEST:
            return {
                ...state,
                isLoadingAllKeyUser: true,
            };
        case ACTIONS.GET_KEYUSER_LIST_SUCCESS:
            return {
                ...state,
                isLoadingAllKeyUser: false,
                listAllKeyUser: action.payload,
            };
        case ACTIONS.GET_KEYUSER_LIST_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingAllKeyUser: false,
            };
        //Obtiene el combo nombres de KeyUsers
        case ACTIONS.GET_KEYUSER_FILTER_REQUEST:
            return {
                ...state,
                isLoadingFilters: true,
            };
        case ACTIONS.GET_KEYUSER_FILTER_SUCCESS:
            let { kuName, systemName } = action.payload;
            return {
                ...state,
                isLoadingFilters: false,
                filter: {
                    listNames: kuName,
                    listSystems: systemName,
                },
            };
        case ACTIONS.GET_KEYUSER_FILTER_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingFilters: false,
            };
        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }
        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload,
            };
        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;

        default:
            return state;
    }
};
